import { render, staticRenderFns } from "./EditQuotaAction.vue?vue&type=template&id=47b01e5f&"
import script from "./EditQuotaAction.vue?vue&type=script&lang=js&"
export * from "./EditQuotaAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports